import * as React from 'react'

interface NonFsdsLpFaqSectionProps {
  title: string
  subtitle: string
  faqs: Array<{ id: string; q: string; a: string }>
  isEnglish: boolean
}

export default function NonFsdsLpFaqSection({ title, subtitle, faqs, isEnglish }: NonFsdsLpFaqSectionProps) {
  return (
    <section data-testid="non-fsds-lp-faq-section" className="bg-blue-50/70 px-4 py-14 sm:px-6 sm:py-16 lg:py-20">
      <div className="mx-auto max-w-6xl">
        {/* Two-column layout: title left, accordion right */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
          {/* Left column */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">{title}</h2>
            <p className="mt-3 text-base leading-relaxed text-slate-600">{subtitle}</p>

            {/* Contact CTA */}
            <div className="mt-6 rounded-2xl border border-blue-100 bg-white p-5">
              <p className="text-sm font-semibold text-slate-900">
                {isEnglish ? 'Still have questions?' : 'Vẫn còn thắc mắc?'}
              </p>
              <p className="mt-1 text-sm text-slate-600">
                {isEnglish
                  ? 'Our team is happy to help you find the right path.'
                  : 'Đội ngũ sẵn sàng giúp bạn tìm lộ trình phù hợp.'}
              </p>
              <a
                href="mailto:support@fsds.ai"
                className="mt-3 inline-flex cursor-pointer items-center rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-blue-700"
              >
                {isEnglish ? 'Contact us' : 'Liên hệ'}
              </a>
            </div>
          </div>

          {/* Right column: accordion */}
          <div className="space-y-3">
            {faqs.map(faq => (
              <details
                key={faq.id}
                className="group rounded-2xl bg-white p-5 ring-1 ring-blue-100 transition-shadow duration-200 hover:shadow-sm"
              >
                <summary className="flex cursor-pointer items-center justify-between pr-2 text-base font-semibold text-slate-900 marker:content-none [&::-webkit-details-marker]:hidden">
                  <span>{faq.q}</span>
                  <svg
                    className="ml-3 size-5 flex-shrink-0 text-blue-500 transition-transform duration-200 group-open:rotate-180"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </summary>
                <p className="mt-3 text-base leading-relaxed text-slate-600">{faq.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
